import { moduloClamp } from 'js/helpers/math';

export function offsetXToFractionalIndex(
  offsetX: number,
  containerWidth: number
): number {
  return (0 - offsetX) / containerWidth;
}

export function fractionalIndexToAbsoluteIndex(
  fractionalIndex: number,
  numImages: number
): number {
  return moduloClamp(Math.round(fractionalIndex), 0, numImages);
}

export function itemPosition(
  itemIndex: number,
  currentFractionalIndex: number,
  containerSize: number,
  numItems: number
): number {
  let itemBaseOffset: number = itemIndex * containerSize;
  const itemsOffset: number = 0 - currentFractionalIndex * containerSize;

  // TODO solve in a more generalized way
  if (numItems > 1) {
    const cycleIndex = Math.floor(currentFractionalIndex / (numItems - 1));
    if (itemIndex === 0 && cycleIndex >= 1) {
      itemBaseOffset += containerSize * numItems;
    } else if (itemIndex === numItems - 1 && cycleIndex < 0) {
      itemBaseOffset -= containerSize * numItems;
    }
  }

  return itemsOffset + itemBaseOffset;
}
